export default __webpack_public_path__ + "static/media/image-deep-earth.2a157951.jpg";